import { AccessType } from '../../types/access-type'
import { StageState } from '../../types/stage-state'
import StageCard from './StageCard'

interface Props {
  stages: {
    id: string
    createdAt: string
    completedAt?: string
    openedAt?: string
    sequenceNumber: number
    title: string
    state: StageState
    deadline: number
    dscription: string
  }[]
  accesses: {
    id: string
    for: AccessType[]
  }[]
}

export default function StagesOverview({ stages, accesses }: Props) {
  return (
    <div
      className="grid auto-rows-max auto-cols-auto px-4 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
      id="stages-list"
    >
      {stages
        ?.sort((a, b) => a.sequenceNumber - b.sequenceNumber)
        .map((stage) => (
          <StageCard
            deadline={stage.deadline}
            title={stage.title}
            createdAt={stage.createdAt}
            openedAt={stage.openedAt}
            completedAt={stage.completedAt}
            sequenceNumber={stage.sequenceNumber.toString()}
            state={stage.state}
            id={stage.id}
            key={stage.id}
            accesses={accesses?.[stage.sequenceNumber]?.for ?? []}
          />
        ))}
    </div>
  )
}
